import type {
  AcknowledgementPage,
  AcknowledgementSubject,
  AcknowledgementWrite,
  AcknowledgementWriteResult,
} from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

/** One delta page request against a subject's acknowledgement log: everything created after `since`, oldest first. */
export type AcknowledgementLogQuery = {
  workspaceId: string;
  subject: AcknowledgementSubject;
  since: string;
  limit?: number;
  cursor?: string;
};

/** Reads one page of a workspace's acknowledgement log for one subject. */
export function listAcknowledgementLog(
  transport: Transport,
  query: AcknowledgementLogQuery,
): Promise<AcknowledgementPage> {
  return operations.getWorkspacesAcknowledgements(transport, query);
}

/**
 * Records a batch of one subject's acknowledgements.
 *
 * Idempotent on each write's `id`, so a retry is safe; every write must be of `subject`.
 */
export function writeAcknowledgementLog(
  transport: Transport,
  args: { workspaceId: string; subject: AcknowledgementSubject; acknowledgements: AcknowledgementWrite[] },
): Promise<AcknowledgementWriteResult> {
  return operations.postWorkspacesAcknowledgements(transport, {
    workspaceId: args.workspaceId,
    subject: args.subject,
    body: { acknowledgements: args.acknowledgements },
  });
}
